const IOS_APP_URL = "https://apps.apple.com/us/app/calii/id1436119504";
const ANDROID_APP_URL = "https://play.google.com/store/apps/details?id=com.calii";

export function getAppStoreUrl(): string {
  if (typeof navigator === "undefined") return IOS_APP_URL;
  const ua = navigator.userAgent;
  if (/android/i.test(ua)) return ANDROID_APP_URL;
  return IOS_APP_URL;
}
